<template>
    <div id="address-card">
        <b-card title="Dirección de entrega" class="mb-2">
            <b-card-text>{{ addressData.street }} {{ addressData.no_ext }}</b-card-text>
            <b-card-text>{{ addressData.suburb }} {{ addressData.cp }}
            </b-card-text>
            <b-card-text>{{ addressData.municipality }}</b-card-text>
            <b-card-text>{{ addressData.references }}</b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "AddressCard",
    props: ['addressData'],
}

</script>

<style scoped>

</style>